import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Wrench, Home, Ticket, User, Bell } from 'lucide-react';

const MobileBottomNav = () => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  if (!user) return null;

  let navItems = [];

  if (user.role === 'technician') {
    navItems = [
      { path: '/technician', icon: Home, label: 'Home' },
      { path: '/tickets', icon: Ticket, label: 'Ticket' },
      { path: '/technician', icon: Wrench, label: 'Lavori', isPrimary: true },
    ];
  } else if (user.role === 'housekeeping') {
    navItems = [
      { path: '/housekeeping', icon: Home, label: 'Segnala' },
      { path: '/tickets', icon: Ticket, label: 'Ticket' },
    ];
  } else if (user.role === 'frontoffice') {
    navItems = [
      { path: '/frontoffice', icon: Home, label: 'Home' },
      { path: '/tickets', icon: Ticket, label: 'Ticket' },
    ];
  } else {
    return null; // No bottom nav for admin roles
  }

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-40 bg-white border-t border-slate-200 safe-area-bottom md:hidden" data-testid="mobile-bottom-nav">
      <div className="flex items-center justify-around h-16 px-2">
        {navItems.map((item) => {
          const isActive = location.pathname === item.path;
          const Icon = item.icon;
          return (
            <button
              key={item.path + item.label}
              onClick={() => navigate(item.path)}
              className={`flex flex-col items-center justify-center gap-0.5 flex-1 h-full transition-colors ${
                item.isPrimary
                  ? 'relative -mt-4'
                  : isActive
                  ? 'text-blue-900'
                  : 'text-slate-400'
              }`}
              data-testid={`bottom-nav-${item.label.toLowerCase()}`}
            >
              {item.isPrimary ? (
                <div className={`w-14 h-14 rounded-2xl flex items-center justify-center shadow-lg ${
                  isActive ? 'bg-blue-900' : 'bg-blue-700'
                }`}>
                  <Icon className="w-6 h-6 text-white" />
                </div>
              ) : (
                <Icon className={`w-5 h-5 ${isActive ? 'text-blue-900' : ''}`} />
              )}
              <span className={`text-[10px] font-medium ${item.isPrimary ? 'text-blue-900 mt-1' : ''}`}>
                {item.label}
              </span>
            </button>
          );
        })}
      </div>
    </nav>
  );
};

export default MobileBottomNav;
